var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlitzquizG(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 133",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "progstroke",
    d: "M122.61,87.17h-8.29c-7.54,20.7-27.51,34.24-52.83,34.24C29.23,121.41,5.4,99,5.4,68.09S29.23,14.92,61.49,14.92c24.8,0,44.47,13,52.34,32.92L68,63.26a8.15,8.15,0,0,0-6.56-3.16,7.79,7.79,0,0,0-8,8,7.92,7.92,0,0,0,8,8.14c4,0,7.76-2.54,7.76-8.09h53.44Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlitzquizG);
export default __webpack_public_path__ + "static/media/glitzquiz-g.abedcf279223480226ded97bdf46fb3f.svg";
export { ForwardRef as ReactComponent };